export default __webpack_public_path__ + "static/media/42.2eafcea1.png";